import { Link } from "react-router-dom";
import { Back2 } from "../../../components/Option/Back";
import Role from "../Role";
import { useEffect, useState } from "react";
import "./index.css";
import { getHighlight, updateHighlight } from "../../../apis/Ambition";
import { SaveAndDiscard, Textareawithsteroids } from "../ESG/EnvironmentReport";
import "../index.css";
import "./index.css";
import { ContainerBody } from "../../../App";
import CustomRow from "./CustomRow";

const Inputtablewithsteroids = ({
  maxLength,
  keyHighlight,
  triggerUpdate,
  triggerGet,
  setTriggerUpdate,
  setTriggerGet,
}) => {
  const [text, setText] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  // const keyHighlight = "yourenvironmentalaim"
  // const maxLength = 2300

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({
      key: keyHighlight,
      setValue: setText,
    });
  };

  const handleUpdate = () => {
    updateHighlight({
      key: keyHighlight,
      value: text,
      swal: false,
    });
  };

  useEffect(() => {
    if (triggerGet) {
      handleGet();
      setTriggerGet(false);
    }
  }, [triggerGet]);

  useEffect(() => {
    if (triggerUpdate) {
      handleUpdate();
      setTriggerUpdate(false);
    }
  }, [triggerUpdate]);

  return (
    <>
      <input
        type="text"
        placeholder={""}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
    </>
  );
};
const Row = ({ heading, keyHighlight, table, question }) => {
  const [updateAlert, setUpdateAlert] = useState();
  const [editInfo, setEditInfo] = useState(false);
  const [text, setText] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [triggerGet, setTriggerGet] = useState(false);

  useEffect(() => {
    getHighlight({
      key: keyHighlight,
      setValue: setText,
    });
  }, []);

  const handleUpdate = () => {
    if (text.length <= 300) {
      setEditInfo(false);
      updateHighlight({
        key: keyHighlight,
        value: text,
      });
    } else {
      setEditInfo(true);
      setErrorMessage("The text may not be longer than 300 characters");
    }
  };

  const handleUpdateTable = () => {
    setTriggerUpdate(!triggerUpdate);
  };

  const handleGetTable = () => {
    setTriggerGet(!triggerGet);
  };

  return (
    <>
      <div className="ambition__role__role mt-2">
        <div className="ambition__ourcompany__item">
          <h5>{heading}</h5>
        </div>
        <div className="ambition__ourcompany__writeinbox__wrapper">
          {/* {!editInfo ? <EditIcon click={()=>setEditInfo(true)}/>:null } */}
          <div className="ambition__ourcompany__writeinbox p-5 pt-4">
            <div className="mb-4">
              <h6 style={{ fontSize: "0.8rem" }}>{question}</h6>
            </div>

            {table ? (
              <>
                <div className="writeinbox__table mb-3">
                  <div className="writeinbox__header">
                    <h5></h5>
                    <h5>Commitment</h5>
                    <h5>KPI</h5>
                  </div>
                  <div className="writeinbox__body">
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Employees</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"employees_commitment"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"employees_kpi"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Company</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"company_commitment"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"company_kpi"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Products</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"products_commitment"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"products_kpi"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Users</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"users_commitment"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"users_kpi"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Society</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"society_commitment"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"society_kpi"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Beyond</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"beyond_commitment"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"beyond_kpi"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="writeinbox__table">
                  <div className="writeinbox__header">
                    <h5></h5>
                    <h5>Starting Point</h5>
                    <h5>Next Year Target</h5>
                    <h5>2030 Target</h5>
                  </div>
                  <div className="writeinbox__body">
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Employees</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"employees_starting"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"employees_nextyear"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"employees_target"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Company</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"company_starting"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"company_nextyear"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"company_target"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Products</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"products_starting"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"products_nextyear"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"products_target"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Users</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"users_starting"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"users_nextyear"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"users_target"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Society</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"society_starting"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"society_nextyear"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"society_target"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                    <div className="writeinbox__row">
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className="writeinbox__row">
                      <h5>Beyond</h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"beyond_starting"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"beyond_nextyear"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                      <h5>
                        <Inputtablewithsteroids
                          keyHighlight={"beyond_target"}
                          triggerGet={triggerGet}
                          triggerUpdate={triggerUpdate}
                          setTriggerUpdate={setTriggerUpdate}
                          setTriggerGet={setTriggerGet}
                        />
                      </h5>
                    </div>
                  </div>
                </div>
                <SaveAndDiscard
                  clickSave={handleUpdateTable}
                  clickDiscard={handleGetTable}
                />
              </>
            ) : (
              <Textareawithsteroids
                keyHighlight={keyHighlight}
                maxLength={"300"}
              />
            )}
            {/* {
                        editInfo ? <div className="companydetail__option__info" style={{justifyContent:"center"}}>
                            <SaveChangeIcon click={()=>{
                                handleUpdate()
                                
                            }}/>
                            <DiscardChangeIcon click={() => {
                                setEditInfo(false)
                                getHighlight({
                                    key:keyHighlight,
                                    setValue:setText
                                })
                            }}/>
                        </div>:null
                    }    */}
          </div>
        </div>
      </div>
    </>
  );
};
const OurCompany = () => {
  const lorem =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
  return (
    <ContainerBody className="ambition__body">
      <div
        className="companydetail__wrapper2"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          height: "0",
        }}
      >
        <Back2
          header={"Back to Company Page"}
          style={{ marginRight: "auto", position: "relative", left: "-7%" }}
          to={"/ambition"}
        />
      </div>
      <div className="ambition__ourcompany__items">
        <div
          className="ambition__role__role"
          style={{ justifyContent: "flex-start" }}
        >
          <Link className="nav-link" to={"/ambition/ourcompany"}>
            <Role title={"Company Ambition"} />
          </Link>
        </div>
        <CustomRow
          heading="History"
          keyHighlight="history"
          question={
            <>
              Describe Company History <br /> How old is your company? How has
              it evolved? How much has it grown?
            </>
          }
        />
        <CustomRow
          heading={"Mission"}
          keyHighlight={"mission"}
          question={
            <>
              Plot in your existing or make a new one. <br /> E.g. What is your
              organisation's purpose? Why does your organisations exist?
            </>
          }
        />
        <CustomRow
          heading={"Vision"}
          keyHighlight={"vision"}
          question={
            <>
              This is the light houwse question, What do you wish to solve on a
              broader and longer term. If we achieved all strategic goals, What
              would we look like 20 years from now?
            </>
          }
        />
        <CustomRow
          heading={"Values"}
          info={lorem}
          keyHighlight={"values"}
          question={
            <>
              What values are unique to your organisation? What values should
              guide the operations of your company? Which values does your
              employees and collaborators appreciate?
            </>
          }
        />
        <CustomRow
          heading="We Provide/Produce"
          question="(This is automatically filled out if you have applied these to the products tab)"
          isPercentageRow={true}
          serviceKey="service_percentage"
          productKey="product_percentage"
        />
        <CustomRow
          heading={"Your Clients & Customers"}
          keyHighlight={"clients"}
          question={
            <>
              Elaborate on your clients and customers <br /> E.g., how many
              people use your product/service worldwide? <br />
              How does your product/service benefit the users/world?
            </>
          }
        />
        <CustomRow
          heading={"Baseline"}
          keyHighlight={"baseline"}
          question={
            <>
              What baseline have you chosen for your company GHG calculations
              and why? <br /> And is it calculated pr. employee, pr. M2, your
              turnaround or? <br />
              <br /> (tip. A baseline is typically the last year before we set
              in with environmental changes and it will be the year we will
              compare the reduction targets to)
            </>
          }
        />
        <Row
          heading={"Roadmap"}
          table={lorem}
          keyHighlight={"roadmap"}
          question={""}
        />
      </div>
    </ContainerBody>
  );
};

export default OurCompany;
